import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _classPrivateFieldGet from "@babel/runtime/helpers/classPrivateFieldGet";
import _classPrivateFieldSet from "@babel/runtime/helpers/classPrivateFieldSet";
import usePointer from '../../../services/pointer.js';
import useRaf from '../../../services/raf.js';
import useResize from '../../../services/resize.js';
import useScroll from '../../../services/scroll.js';
import useKey from '../../../services/key.js';
import useLoad from '../../../services/load.js';
import { hasMethod, callMethod } from '../utils.js';
var SERVICES_MAP = {
  scrolled: useScroll,
  resized: useResize,
  ticked: useRaf,
  moved: usePointer,
  keyed: useKey,
  loaded: useLoad
};

var _base = new WeakMap();

var Services = function () {
  function Services(instance) {
    _classCallCheck(this, Services);

    _base.set(this, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldSet(this, _base, instance);
  }

  _createClass(Services, [{
    key: "has",
    value: function has(service) {
      if (!hasMethod(_classPrivateFieldGet(this, _base), service) && !SERVICES_MAP[service]) {
        return false;
      }

      var _SERVICES_MAP$service = SERVICES_MAP[service](),
          has = _SERVICES_MAP$service.has;

      return has(_classPrivateFieldGet(this, _base).$id);
    }
  }, {
    key: "enable",
    value: function enable(service) {
      if (this.has(service)) {
        return this.disable.bind(this, service);
      }

      if (!hasMethod(_classPrivateFieldGet(this, _base), service) || !SERVICES_MAP[service]) {
        return function noop() {};
      }

      var _SERVICES_MAP$service2 = SERVICES_MAP[service](),
          add = _SERVICES_MAP$service2.add;

      var self = this;

      function serviceHandler() {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        callMethod.apply(void 0, [_classPrivateFieldGet(self, _base), service].concat(args));
      }

      add(_classPrivateFieldGet(this, _base).$id, serviceHandler);
      return this.disable.bind(this, service);
    }
  }, {
    key: "enableAll",
    value: function enableAll() {
      var _this = this;

      return Object.keys(SERVICES_MAP).map(function (serviceName) {
        return _this.enable(serviceName);
      });
    }
  }, {
    key: "disableAll",
    value: function disableAll() {
      var _this2 = this;

      Object.keys(SERVICES_MAP).forEach(function (serviceName) {
        _this2.disable(serviceName);
      });
    }
  }, {
    key: "disable",
    value: function disable(service) {
      if (!SERVICES_MAP[service]) {
        return;
      }

      var _SERVICES_MAP$service3 = SERVICES_MAP[service](),
          remove = _SERVICES_MAP$service3.remove;

      remove(_classPrivateFieldGet(this, _base).$id);
    }
  }, {
    key: "register",
    value: function register(name, useFunction) {
      SERVICES_MAP[name] = useFunction;
    }
  }, {
    key: "unregister",
    value: function unregister(name) {
      delete SERVICES_MAP[name];
    }
  }]);

  return Services;
}();

export { Services as default };
//# sourceMappingURL=Services.js.map